import './styles.scss';

import { get } from 'lodash';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import Button from 'src/components/Button';
import { exportAllPagesToFile, importPagesFromFile } from 'src/modules/importExport/actions';
import styled from 'styled-components';

export interface IBackupProps {
  canImportFrom750?: boolean;
  canImportFromDayOne?: boolean;
}

const translationsScope = 'components.Profile.BackupRestore';

const RestoreButton = styled(Button)`
  margin-top: 10px;
`;

const ProfileBackup: React.FunctionComponent<IBackupProps> = props => {
  const dispatch = useDispatch();

  const onExportAll = () => {
    dispatch(exportAllPagesToFile());
  };

  const onImportFromFile = (event: React.FormEvent) => {
    const loadedFile = get(event, ['target', 'files', 0], null);

    dispatch(importPagesFromFile(loadedFile));
  };

  // const handleImportFrom750Words = (event: Event) => {
  //   const loadedFile = get(event, ['target', 'files', 0], null);

  //   dispatch(importPagesFrom750Words(loadedFile));
  // };

  // const handleImportFromDayOne = (event: Event) => {
  //   const loadedFile = get(event, ['target', 'files', 0], null);

  //   dispatch(importPagesFromDayOne(loadedFile));
  // };

  return (
    <div className="ImportExport-column">
      <div className="ImportExport-title">
        <FormattedMessage id={`${translationsScope}.title`} />
      </div>
      <div className="ImportExport-row">
        <div className="ImportExport-column">
          <div className="ImportExport-value">
            <FormattedMessage id={`${translationsScope}.backupDescr`} />
          </div>
        </div>
        <div className="ImportExport-column">
          <div className="ImportExport-button">
            <Button color="grey" outline={true} block={true} onClick={onExportAll}>
              <FormattedMessage id={`${translationsScope}.backupAction`} />
            </Button>
          </div>
          <div className="ImportExport-button">
            <RestoreButton color="grey" outline={true} block={true} onChange={onImportFromFile} openFile={true}>
              <FormattedMessage id={`${translationsScope}.restoreAction`} />
            </RestoreButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo<IBackupProps>(ProfileBackup);



// WEBPACK FOOTER //
// ./src/components/ProfileBackup/index.tsx